// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#__layout,#__nuxt,.v-application,.v-application--wrap,html{height:100%}#__layout,#__nuxt,.v-application,.v-application--wrap,body,html{display:flex;flex:1 0 auto;flex-direction:column;min-height:100%}", ""]);
// Exports
module.exports = exports;
